export default __webpack_public_path__ + "static/media/inactive-exercise.e97080cf.svg";